import React from 'react'
import Report from '../Component/Laporan/Report'
import Copyright from '../Component/Homepage/Copyright'
import Footer from '../Component/Homepage/Footer'
import Header from '../Component/Homepage/Header'


function Laporan() {
  return (
    <>
    <Header/>
    <Report/>
    <Footer/>
    <Copyright/>
    </>
  )
}

export default Laporan